import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import {
    Link,
    withRouter,
    useHistory,
    useParams,
    useLocation,
} from 'react-router-dom';
import logoPergamum from '../../../../../images/pergamum.svg'
import { LayoutHelper } from '../../../../shared/helpers';

import { toast, ToastContainer } from 'react-toastify';
import { connect, useDispatch } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import Axios from 'axios';
import classnames from 'classnames';
import MiddlewareLogin from '../../../../routers/MiddlewareLogin';

import {
    ModalConstructor,
    SpinnerConstructor,
    Footer,
} from '../../../../shared/components';
import AccessibilityBar from '../../../consulta-acessibilidade/AccessibilityBar';

import {
    ConsultaAPI,
    PergamumKidsLayout,
} from '../../../../shared/http-requests';

import {
    changeCapaPadrao,
    changePagePrefix,
    insertBreadCrumbAction,
    insertLibraries,
    selectedCategoryAction,
    selectedLibraryAction,
    loadingLibrariesAction,
    changeLabelsDadosAcervo,
    changeLabelsAction,
    toInitialState,
    changeLoadingLabels,
} from '../../../../store/ducks/pergamumKids';


import { ImageHelper } from '../../../../shared/helpers/ImageHelper';
import LoadingPage from '../../components/LoadingPage';
import { ToastifyHelper } from '../../../../shared/helpers';
import DadosDoAcervoCompleto from '../components/DadosDoAcervoCompleto';
import { StyleHelper } from '../../../../shared/helpers/StyleHelper';
import PergamumProcessImage from '../../../../shared/components/CoverImage';
import AccessibilityContextProvider from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';

const GuiasConteudoPersonalizado = React.lazy(() =>
    import('../../components/BaseTemplate/GuiasConteudoPersonalizado'),
);
const InfoAsks = React.lazy(() =>
    import('../../components/BaseTemplate/InfoAsks'),
);
const Div = React.lazy(() => import('../../components/html/Div'));
const Go2Top = React.lazy(() => import('../../components/html/Go2Top'));
const MenuUsuario = React.lazy(() => import('../../components/MenuUsuario'));

const DadosDoAcervo = React.lazy(() => import('../components/DadosDoAcervo'));
const LayoutController = React.lazy(() =>
    import('../components/LayoutController'),
);

function BaseTemplateTeen({
    extras = true,
    userLocalRx,
    userSessionRx,
    libraries,
    changeView,
    layoutData,
    selectedLibraryId,
    selectedCategory,
    searchText,
    loadingSearchResult,
    currentPage,
    showDadosAcervo,
    localizacao,
    breadCrumbProps,
    categories,
    acervoCompleto,
    linkCurrent,
    bibliotecaTipoCatalogoKids,
    capaPadrao,
    pagePrefix,
    labels,
    ...props
}) {
    const history = useHistory();
    const location = useLocation();

    const dispatch = useDispatch();

    const user = userLocalRx || userSessionRx;

    const [renovar, setRenovar] = useState(false);

    const [allowedAccess, setAllowedAccess] = useState(false);

    const [defaultImages, setDefaultImages] = useState(null);

    const [bgImage, setBgImage] = useState(null);

    const [logoImage, setLogoImage] = useState(null);

    const [visual, setVisual] = useState(null);

    const [loading, setLoading] = useState(false);

    const [defaultCoverConfig, setDefaultConverConfig] = useState(false);

    const { setSelectedTab } = useAppContext()

    useEffect(() => {
        setSelectedTab('kids')
        return () => {
            setSelectedTab(null)
        }
    }, []);

    const params = useParams();

    const { prefix } = params;
    const contentRef = useRef(null);

    const fetchLibraries = useCallback(async (cancelToken = null) => {
        try {
            dispatch(loadingLibrariesAction(true));
            const response = await PergamumKidsLayout.getLibraries(cancelToken);
            const { data } = response;

            if (data) {
                /**
                 * Se houver apenas 1 bibliotéca a tela carrega com os dados dela, sem a necessidade do seletor
                 */
                if (data?.length === 1) {
                    dispatch(selectedLibraryAction(data[0]?.cod_biblioteca));
                }

                dispatch(insertLibraries(data));
            }

            dispatch(loadingLibrariesAction(false));
        } catch (e) {
            dispatch(loadingLibrariesAction(false));
        }
    }, []);

    const fetchLabelsDadosAcervo = useCallback(
        async (selectedLibraryId, cancelToken = null) => {
            try {
                const response = await PergamumKidsLayout.getLabelsDadosAcervo(
                    selectedLibraryId,
                    cancelToken,
                );
                const { data } = response;

                if (data) {
                    dispatch(changeLabelsDadosAcervo(data));
                }
            } catch (e) {
                if (!Axios.isCancel(e)) {
                    console.error('Error on request "labels dados acervo" ', e);
                }
            }
        },
        [],
    );

    const fetchLabelsDados = useCallback(
        async (selectedLibraryId, cancelToken = null) => {
            try {
                dispatch(changeLoadingLabels(true));
                const response = await PergamumKidsLayout.getLabels(
                    selectedLibraryId,
                    cancelToken.token,
                );
                const { data } = response;

                if (data) {
                    dispatch(changeLabelsAction(data));
                }

                dispatch(changeLoadingLabels(false));
            } catch (e) {
                console.error('Error on request "labels" ', e);
                dispatch(changeLoadingLabels(false));
            }
        },
        [],
    );

    useEffect(() => {
        if (selectedLibraryId === 0) return;

        const cancelTokenSource = Axios.CancelToken.source();
        const { token } = cancelTokenSource;

        (async () => {
            try {
                await fetchLabelsDadosAcervo(selectedLibraryId, token);
                if (Object.keys(labels).length === 0) {
                    await fetchLabelsDados(selectedLibraryId, token);
                }
            } catch (e) {
                if (Axios.isCancel(e)) {
                    console.log('canceled');
                }
            }
        })();

        return () => {
            cancelTokenSource.cancel();
        };
    }, [selectedLibraryId, labels]);

    useEffect(() => {
        if (visual !== null) {
            const cancelTokenSource = Axios.CancelToken.source();
            const { token } = cancelTokenSource;
            const { opc_catalogo } = visual;

            if (
                opc_catalogo === 'UI' ||
                (opc_catalogo === 'IN' && Object.keys(labels).length === 0)
            ) {
                (async () => {
                    await fetchLabelsDados(selectedLibraryId, token);
                })();
            }
        }
    }, [visual]);

    useEffect(() => {
        if (selectedLibraryId !== 0) return;

        const cancelTokenSource = Axios.CancelToken.source();
        const { token } = cancelTokenSource;

        (async () => {
            // await fetchLibraries(token);
            await fetchDefaultCoverConfig(token);
        })();

        return () => cancelTokenSource.cancel();
    }, [selectedLibraryId]);

    useEffect(() => {
        const cancelTokenSource = Axios.CancelToken.source();
        const { token } = cancelTokenSource;

        if (libraries === null) {
            (async () => {
                await fetchLibraries(token);
            })();
        }

        return () => cancelTokenSource.cancel();
    }, [libraries]);

    useEffect(() => {
        if (pagePrefix === null || pagePrefix !== prefix) {
            dispatch(changePagePrefix(prefix));

            /**
             * Valida prefixo
             */
            if (!['museus', 'kids'].includes(prefix)) {
                history.push('/');
            }
        }
    }, [prefix, pagePrefix]);

    const fetchDefaultCoverConfig = useCallback(async (cancelToken = null) => {
        try {
            const response = await ConsultaAPI.buscarImagemPadrao(cancelToken);
            const { data } = await response;
            if (data) {
                const { data } = response;
                const { capa_cor_fonte_padrao_classico, capa_padrao_classico } =
                    data;
                setDefaultConverConfig({
                    capa_cor_fonte_padrao_classico,
                    capa_padrao_classico,
                });
            }
        } catch (error) {
            if (!Axios.isCancel(error)) {
                console.error('Error on request default cover config', error);
            }
        }
    }, []);

    /**
     * Busca capa  padrao
     */
    useEffect(() => {
        if (visual === null) return;

        const cancelToken = Axios.CancelToken.source();

        const { capa_cor_fonte_padrao_kids, capa_padrao_kids } = visual;

        if (capa_cor_fonte_padrao_kids?.trim() && capa_padrao_kids?.trim()) {
            dispatch(
                changeCapaPadrao({
                    cor: capa_cor_fonte_padrao_kids,
                    capa: capa_padrao_kids,
                }),
            );
        } else {
            const { capa_cor_fonte_padrao_classico, capa_padrao_classico } =
                defaultCoverConfig ?? {};
            dispatch(
                changeCapaPadrao({
                    cor: capa_cor_fonte_padrao_classico,
                    capa: capa_padrao_classico,
                }),
            );
        }

        return () => cancelToken.cancel();
    }, [visual]);

    /**
     * Acesso com parâmetros: Biblioteca
     */
    useEffect(() => {
        if (showDadosAcervo) return;

        const { codBiblioteca } = params;

        if (codBiblioteca && libraries !== null) {
            if (!libraries.some(l => l.cod_biblioteca === codBiblioteca)) {
                ToastifyHelper.warning('Biblioteca inválida.');
                return;
            }

            dispatch(selectedLibraryAction(codBiblioteca));
        }
    }, [libraries]);

    /**
     * Acesso com parâmetros: Categoria
     */
    useEffect(() => {
        if (showDadosAcervo || selectedCategory !== null) return;

        const { codCategoria } = params;

        if (codCategoria === '*') {
            dispatch(selectedCategoryAction(codCategoria));
            return;
        }

        if (codCategoria && categories !== null) {
            if (categories.find(c => c.cod_categoria == codCategoria)) {
                dispatch(
                    selectedCategoryAction(
                        categories.find(c => c.cod_categoria == codCategoria),
                    ),
                );
            } else {
                ToastifyHelper.warning('Categoria inválida.');
            }
        }
    }, [categories]);

    /**
     * Controle de acesso
     */
    useEffect(() => {
        if (prefix === null) return;

        const cancelToken = Axios.CancelToken.source();

        if (prefix === 'kids') {
            PergamumKidsLayout.checkInstitutionPermission(cancelToken.token)
                .then(result => {
                    const { data } = result;
                    if (data) {
                        const { permission } = data;

                        if (permission === false) {
                            history.push('/');
                            return;
                        }

                        setAllowedAccess(true);
                    }
                })
                .catch(() => {
                    history.push('/');
                });
        }

        return () => cancelToken.cancel();
    }, [prefix]);

    /**
     * Busca a imagem de fundo e o logo padrão
     */
    useEffect(() => {
        if (!loading) setLoading(true);
        const cancelToken = Axios.CancelToken.source();

        PergamumKidsLayout.getDefaultBgAndLogo(cancelToken.token)
            .then(response => {
                const { data } = response;
                if (data) {
                    const { logotipo_consulta, imagem_fundo_consulta } = data;
                    setDefaultImages({
                        bg: imagem_fundo_consulta,
                        logo: logotipo_consulta,
                    });
                }
                setLoading(false);
            })
            .catch(error => {
                if (!Axios.isCancel(error)) {
                    console.log(error);
                    setLoading(false);
                }
            });

        return () => cancelToken.cancel();
    }, []);

    /**
     * Busca dados do visual
     */
    useEffect(() => {
        if (defaultImages == null) return;

        if (!loading) setLoading(true);

        const cancelToken = Axios.CancelToken.source();

        PergamumKidsLayout.getVisual(selectedLibraryId, cancelToken.token)
            .then(response => {
                const { data } = response;

                if (data) {
                    const { nom_textura_kids, nom_logo_kids } = data;

                    ImageHelper.testImage(nom_textura_kids)
                        .then(() => setBgImage(nom_textura_kids))
                        .catch(() => setBgImage(defaultImages?.bg));

                    ImageHelper.testImage(nom_logo_kids)
                        .then(() => setLogoImage(nom_logo_kids))
                        .catch(() => setLogoImage(logoPergamum));

                    setVisual(data);
                    setLoading(false);
                    return;
                }
                setVisual([]);

                setLoading(false);
            })
            .catch(error => {
                if (!Axios.isCancel(error)) {
                    setVisual([]);
                    setLoading(false);
                    console.log(error);
                }
            });

        return () => cancelToken.cancel();
    }, [defaultImages, selectedLibraryId]);

    useEffect(() => {
        setRenovar(
            user.renovar &&
                !user.expirado &&
                localStorage.getItem('msg_shwnd') == '1',
        );
        localStorage.removeItem('msg_shwnd');
    }, [user]);

    useEffect(() => {
        const { codAcervo, codBiblioteca } = params;
        if (codAcervo && codBiblioteca && showDadosAcervo === true) {
            dispatch(selectedLibraryAction(codBiblioteca));
        }
    }, []);

    useEffect(() => {
        if (prefix === null) return;

        dispatch(
            insertBreadCrumbAction({
                backButtonLabel: null,
                breadCrumbImage: null,
                breadCrumbLabel: [],
                onClickBack: null,
                onClickGoHome: null,
            }),
        );
    }, [prefix, selectedLibraryId]);

    const { t } = useTranslation();
    const [top, setTop] = useState(false);

    const getBgLogo = () => {
        if(visual?.opc_catalogo ==='IN'){
            return visual?.cor_logo_kids_fundo ? `rgba(${visual?.cor_logo_kids_fundo})` : 'rgb(255,255,255)'
        }
       return  layoutData?.cor_logo_kids_fundo ? `rgba(${layoutData?.cor_logo_kids_fundo})` : 'rgb(255,255,255)'
    }

    if (loading) {
        return <LoadingPage />;
    }

    return (
        <AccessibilityContextProvider>
            <div
                id="content"
                className={[
                    'app acessibilidade',
                    bibliotecaTipoCatalogoKids == '1' ? 'museu' : 'teen',
                    props.acessibilidadeRx.cor === 'contraste'
                        ? 'temaAltoContraste alto-contraste'
                        : 'tema-pergamum',
                    props.acessibilidadeRx.zoom
                        ? `zoom-${props.acessibilidadeRx.zoom}`
                        : null,
                    props.acessibilidadeRx.negrito ? 'negrito' : null,
                    props.acessibilidadeRx.cor,
                ].join(' ')}
            >
                <AccessibilityBar showDarkMode={false} />
                <ModalConstructor open={props.loadingRx} size="xs">
                    <div className="p-4 text-center">
                        {props.loadingRx && (
                            <div>
                                <SpinnerConstructor
                                    visible
                                    height={60}
                                    width={60}
                                    className="apergamum"
                                />
                                <div className="mt-3">
                                    <span className="preto70 s17 f400">
                                        {t('PesquisandoAguarde')}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                </ModalConstructor>
                <Modal isOpen={renovar}>
                    <ModalHeader>{t('Atencao')}</ModalHeader>
                    <ModalBody>
                        {props.instituicaoRx.msg_renovacao_consulta || (
                            <>{t('msg_renovacao_consulta')}</>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => renovarValidade()}
                        >
                            {t('Sim')}
                        </Button>{' '}
                        <Button
                            color="secondary"
                            onClick={() => setRenovar(false)}
                        >
                            {t('Nao')}
                        </Button>
                    </ModalFooter>
                </Modal>

                <div className="">
                    <div
                        className="d-none d-sm-block"
                        style={{ position: 'absolute', width: '100%' }}
                    >
                        <a
                            href={`/catalogos/${prefix}`}
                            className="img_logo d-none d-sm-block"
                            style={{
                                backgroundImage: `url('${logoImage}')`,
                                backgroundColor: getBgLogo(),
                            }}
                            target={
                                props.instituicaoRx.link_logo_consulta
                                    ? '_blank'
                                    : '_self'
                            }
                            rel="noreferrer"
                        >
                            <span className="sr-only">Logo</span>
                        </a>

                        {user ? (
                            <MenuUsuario />
                        ) : (
                            <Link
                                to={{
                                    pathname: '/login',
                                    search: `?redirect=${window.location.pathname}`,
                                }}
                                className={classnames(
                                    'b-solid b-teen3 b-w3 bklight90 bkroxo branco d-none d-sm-block f700 hover hpreto nolink pad10 px-4 s14 sombraPadrao sroxo topLinkSpace2',
                                    {
                                        teen: bibliotecaTipoCatalogoKids != '1',
                                        museu:
                                            bibliotecaTipoCatalogoKids == '1',
                                    },
                                )}
                            >
                                <FontAwesomeIcon
                                    icon="user"
                                    className="hover1 r5"
                                    fixedWidth
                                />
                                {t('Login')}
                            </Link>
                        )}
                    </div>

                    {/* CONTAINER COM TEXTURA NO FUNDO */}
                    <div
                        className="sombra"
                        style={{
                            backgroundImage: StyleHelper.getImageWithColor(
                                visual?.cor_textura_kids ||
                                layoutData?.cor_textura_kids,
                                visual?.perc_cor_textura ||
                                layoutData?.perc_cor_textura,
                                bgImage,
                            ),
                            backgroundRepeat: 'repeat',
                            backgroundPosition: 'top center',
                        }}
                    >
                        <div className="">
                            <div className="img_topo_biblioteca">
                                {(showDadosAcervo && acervoCompleto && (
                                        <DadosDoAcervoCompleto
                                            extras={extras}
                                            linkCurrent={linkCurrent}
                                        />
                                    )) ||
                                    (showDadosAcervo && <DadosDoAcervo />) ||
                                    (visual !== null && (
                                        <LayoutController
                                            visual={visual}
                                            setBgImage={setBgImage}
                                            setLogoImage={setLogoImage}
                                        />
                                    )) || <div />}
                            </div>
                        </div>
                    </div>
                    {/* .CONTAINER COM TEXTURA NO FUNDO */}
                </div>

                <div
                    className={classnames({
                        'bkteen_neutro kids': bibliotecaTipoCatalogoKids != '1',
                        'bkmuseu_neutro museu':
                            bibliotecaTipoCatalogoKids == '1',
                    })}
                >
                    <div className="b-teen idBorda" />
                    <Div
                        className="body main-container-kids"
                        onLoad={ref => {
                            ref.scrollIntoView({
                                block: 'start',
                                inline: 'nearest',
                                behavior: 'smooth',
                            });
                        }}
                    >
                        {props.children}
                    </Div>
                    {extras && (
                        <>
                            <GuiasConteudoPersonalizado/>
                            <InfoAsks tipo_catalogo="k" />
                        </>
                    )}
                </div>

                {/* Novo botão para ir ao topo */}
                <Go2Top
                    onClick={() =>
                        document.querySelector('#content').scrollIntoView({
                            block: 'start',
                            inline: 'nearest',
                            behavior: 'smooth',
                        })
                    }
                    visible={top}
                    t={t}
                />
                {/* 10/01 - Novo rodapé */}
                <Footer showLinks />
                <ToastContainer
                    autoClose={8000}
                    position={toast.POSITION.TOP_CENTER}
                />
            </div>
        </AccessibilityContextProvider>
    );
}

const mapStateToProps = state => ({
    opcoesConsultaRx: state.pesquisa.opcoesConsulta,
    instituicaoRx: state.instituicao.data,
    acessibilidadeRx: state.pageConfig.acessibilidade,
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
    loadingRx: state.pageConfig.loading,

    libraries: state.pergamumKids.libraries,
    layoutData: state.pergamumKids.layoutData,
    selectedLibraryId: state.pergamumKids.selectedLibraryId,
    selectedCategory: state.pergamumKids.selectedCategory,
    searchText: state.pergamumKids.searchText,
    loadingSearchResult: state.pergamumKids.loadingSearchResult,
    currentPage: state.pergamumKids.currentPage,
    breadCrumbProps: state.pergamumKids.breadCrumbProps,
    categories: state.pergamumKids.categories,
    bibliotecaTipoCatalogoKids: state.pergamumKids.bibliotecaTipoCatalogoKids,
    capaPadrao: state.pergamumKids.capaPadrao,
    pagePrefix: state.pergamumKids.pagePrefix,
    labels: state.pergamumKids.labels,
});

export default connect(mapStateToProps)(
    withRouter(MiddlewareLogin(BaseTemplateTeen)),
);
